<template>
    <section class="SlideshowNavigation ContentSection ContentSection--hasclippath">
        <h4 v-html="properties.title"></h4>
        <article class="SlideshowNavigation__linkwrapper">
            <div>
                <transition-group :name="animations[direction].name">
                    <router-link v-for="(link, i) in properties.hotspots" :key="link.title" :to="getRouteFromID(link.sceneLink)" v-show="activeHotspot === i" v-html="link.title"></router-link>
                </transition-group>
            </div>
        </article>
        <article class="SlideshowNavigation__hotspotwrapper">
            <button class="SlideshowNavigation__hotspotwrapper__button SlideshowNavigation__hotspotwrapper__button--prev" @click="hotspotPrev"></button>
            <button class="SlideshowNavigation__hotspotwrapper__button SlideshowNavigation__hotspotwrapper__button--next" @click="hotspotNext"></button>
        
            <div v-for="(hotspot, i) in properties.hotspots" @click="selectHotspot(i)" :key="hotspot.title" class="SlideshowNavigation__hotspotwrapper__hotspot" :style="getHotspotStyle(hotspot, i)"></div>

            <img v-if="properties.image" :src="getMediaPath(properties.image.src)">
        </article>
    </section>
</template>
<script>
export default {
    props: ["properties", "pageData"],
    data() {
        return {
            activeHotspot: 0,
            direction: "left",
            animations: {
                left: {
                    name: "fadeOutRight"
                },
                right: {
                    name: "fadeOutLeft"
                }
            }
        }
    },
    mounted() {
        this.activeHotspot = this.getRandomStart();
    },
    methods: {
        selectHotspot(i) {
            this.activeHotspot = i;
        },
        hotspotPrev() {
            if(this.activeHotspot !== 0) {
                this.activeHotspot--;
            } else {
                this.activeHotspot = this.properties.hotspots.length - 1;
            }
            this.direction = "left"
        },
        hotspotNext() {
            if(this.activeHotspot < this.properties.hotspots.length - 1) {
                this.activeHotspot++;
            } else {
                this.activeHotspot = 0;
            }
            this.direction = "right"
        },
        getHotspotStyle(hotspot, i) {
            return {
                left: `${hotspot.xPosition}%`,
                top: `${hotspot.yPosition}%`,
                opacity: `${this.activeHotspot == i ? '1' : '0.3'}`
            }
        },
        getRandomStart() {
            let length = this.properties.hotspots.length - 1;

            return Math.floor(Math.random() * length);
        },


        getMediaPath(src) {
            return app.manifest.getMediaPath(src)
        },
        getRouteFromID(id) {
            return app.manifest.getRouteFromID(id);
        }
    }
}
</script>
<style lang="scss">
    @import '@/assets/sass/_responsiveness.scss';
    .SlideshowNavigation {
        display: flex;
        align-items: center;
        flex-direction: column;
        text-align: left;
        padding: 100px 0 0 0;
        background: var(--light-grey);

        h4 {
            margin-bottom: 20px;    
        }

        &>article {
            width: 100%;
            max-width: var(--content-max-width);
            padding: var(--content-padding);
        }

        .SlideshowNavigation__linkwrapper {
            &> div{
                position: relative;
                background: #fff;
                height: 75px;
                border-radius: 29px;
                padding-left: 40px;
                overflow: hidden;
                box-shadow: var(--shadow-medium);

                &>a {
                    position: absolute;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    height: 100%;
                    font-size: 20px;
                }

                &::after {
                    content: '';
                    position: absolute;
                    height: 28px;
                    width: 15px;
                    right: 35px;
                    top: 50%;
                    transform: translateY(-50%);
                    background-image: url(@/assets/img/ui/btn-arrow.svg);
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: 100%;
                    transition: var(--tk-easeinout) 0.2s transform;
                }
                &:hover {
                    &::after {
                        transform: translateY(-50%) translateX(5px);
                    }
                }
            }
        }

        .SlideshowNavigation__hotspotwrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;

            .SlideshowNavigation__hotspotwrapper__button {
                position: absolute;
                top: 200px;
                transform: translateY(-50%);
                width: 60px;
                height: 60px;
                cursor: pointer;
                border-radius: 1000px;
                background-image: url(@/assets/img/ui/btn-next.svg);
                background-position: center;
                background-repeat: no-repeat;
                transform-origin: 50% 0;
                transition: var(--tk-easeinout) 0.1s transform;

                &.SlideshowNavigation__hotspotwrapper__button--prev {
                    right: calc(100% + 60px);
                    rotate: 180deg;
                }

                &.SlideshowNavigation__hotspotwrapper__button--next {
                    left: calc(100% + 60px);
                }

                &.SlideshowNavigation__hotspotwrapper__button--inactive {
                    background-image: url(@/assets/img/ui/btn-next-outline.svg);
                }

                &:hover {
                    transform: scale(1.05) translateY(-50%);
                }
            }            

            .SlideshowNavigation__hotspotwrapper__hotspot {
                position: absolute;
                left: 0;
                top: 0;
                width: 50px;
                height: 50px;
                background-image: url(@/assets/img/ui/hotspot.png);
                background-position: center;
                background-repeat: no-repeat;
                background-size: 150%;
                transition: opacity 0.2s ease;
                cursor: pointer;
            }
            
            
            &>img {
                max-width: var(--content-max-width-nopadding);
                height: 100%;
            }
        }
        
        @include tablet-down {
            .SlideshowNavigation__hotspotwrapper {
                margin-bottom: 50px;
                
                .SlideshowNavigation__hotspotwrapper__button {
                    position: absolute;
                    width: 50px;
                    height: 50px;
                    top: auto;
                    bottom: -60px;
                    
                    &.SlideshowNavigation__hotspotwrapper__button--prev {
                        right: 80px;
                    }
                    
                    &.SlideshowNavigation__hotspotwrapper__button--next {
                        left: auto;
                        right: 20px;
                    }
                }  
            }
        }
        
        
        @include mobile-only {
            .SlideshowNavigation__linkwrapper {
                > div {
                    &::after {
                        height: 23px;
                        width: 12px;
                        right: 20px;
                    }
                }
            }

            .SlideshowNavigation__hotspotwrapper {
                .SlideshowNavigation__hotspotwrapper__button {
                    width: 40px;
                    height: 40px;
                }
                
                .SlideshowNavigation__hotspotwrapper__hotspot {
                    width: 30px;
                    height: 30px;
                }
            }
        }
    }
</style>